export default {
  SET_IS_DRAFT (state, isDraft) {
    state.isDraft = isDraft
  },
  SET_INVITE_CODE (state, inviteCode) {
    state.inviteCode = inviteCode
  },
  SET_PERMISSIONS (state, permissions) {
    state.permissions = permissions
  },
  SET_PERMISSIONS_SIGNATURE (state, permissionsSignature) {
    state.permissionsSignature = permissionsSignature
  },
  SET_PERMISSION (state, permission) {
    state.permissions.unshift(permission)
  },
  SET_PERMISSION_SIGNATURE (state, permission) {
    state.permissionsSignature.unshift(permission)
  },
  UPDATE_PERSON (state, person) {
    const { userPersonId } = person
    const index = state.persons.findIndex((e) => e.userPersonId === userPersonId)
    if (index !== -1) {
      Object.assign(state.persons[index], person)
    }
  },
  DELETE_PERMISSION (state, permissionId) {
    const index = state.permissions.findIndex((e) => e.id === permissionId)
    state.permissions.splice(index, 1)
  },
  SET_PERMISSION_APPLICATION_ID (state, applicatonId) {
    state.applicationId = applicatonId
  }
}
